/* eslint-disable react-refresh/only-export-components */
import { cn } from "@/lib/utils";
import { cva, type VariantProps } from "class-variance-authority";
import * as React from "react";

const badgeVariants = cva(
  "inline-flex items-center rounded border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2",
  {
    variants: {
      variant: {
        default:
          "border-transparent bg-primary text-primary-foreground hover:bg-primary/80",
        secondary:
          "border-transparent bg-[#DEE3E7] text-secondary-foreground hover:bg-[#DEE3E7]/80",
        destructive:
          "border-transparent bg-destructive text-destructive-foreground hover:bg-destructive/80",
        purple:
          "border-transparent bg-[#CBCAE8] text-[#615CB7] hover:bg-[#CBCAE8]/80",
        orange:
          "border-transparent bg-[#FFCEA9] text-[#ED3E09] hover:bg-[#FFCEA9]/80",
        gold: "border-transparent bg-[#FFE2A8] text-[#B37700] hover:bg-[#FFE2A8]/80",
        green: "border-transparent text-[#186235] bg-[#E6F9EE]",
        sky: "border-transparent text-[#149CD1] bg-[#E8F7FD]",
        outline: "text-foreground",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  },
);

export interface BadgeProps
  extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof badgeVariants> {}

function Badge({ className, variant, ...props }: BadgeProps) {
  return (
    <div className={cn(badgeVariants({ variant }), className)} {...props} />
  );
}

export { Badge, badgeVariants };
